"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdown = exports.Select = exports.Option = exports.Label = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledDropdown = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.border.radius;
}, _ref2 => {
  var _theme$components, _theme$components$dro;

  let {
    theme
  } = _ref2;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$dro = _theme$components.dropdown) === null || _theme$components$dro === void 0 ? void 0 : _theme$components$dro.dropdown;
});

exports.StyledDropdown = StyledDropdown;

const Select = _styledComponents.default.select(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 5px 10px;\n  background-color: ", ";\n  outline: none;\n  font-size: ", ";\n  color: ", ";\n  border-radius: ", ";\n  border: thin solid ", ";\n  display: block;\n  width: 100%;\n  cursor: pointer;\n  @media (max-width: ", ") {\n    font-size: ", ";\n  }\n  ", ";\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color.background.primary;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.font.size.md;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.color.font.primary;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.border.radius;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.color.border.primary;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.breakpoint.md;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.font.size.sm;
}, _ref10 => {
  var _theme$components2, _theme$components2$dr;

  let {
    theme
  } = _ref10;
  return theme === null || theme === void 0 ? void 0 : (_theme$components2 = theme.components) === null || _theme$components2 === void 0 ? void 0 : (_theme$components2$dr = _theme$components2.dropdown) === null || _theme$components2$dr === void 0 ? void 0 : _theme$components2$dr.select;
});

exports.Select = Select;

const Option = _styledComponents.default.option(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), _ref11 => {
  var _theme$components3, _theme$components3$dr;

  let {
    theme
  } = _ref11;
  return theme === null || theme === void 0 ? void 0 : (_theme$components3 = theme.components) === null || _theme$components3 === void 0 ? void 0 : (_theme$components3$dr = _theme$components3.dropdown) === null || _theme$components3$dr === void 0 ? void 0 : _theme$components3$dr.option;
});

exports.Option = Option;

const Label = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  margin-bottom: 5px;\n  @media (max-width: ", ") {\n    font-size: ", ";\n  }\n  ", ";\n"])), _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.color.font.primary;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.font.size.md;
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.breakpoint.md;
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.font.size.sm;
}, _ref16 => {
  var _theme$components4, _theme$components4$dr;

  let {
    theme
  } = _ref16;
  return theme === null || theme === void 0 ? void 0 : (_theme$components4 = theme.components) === null || _theme$components4 === void 0 ? void 0 : (_theme$components4$dr = _theme$components4.dropdown) === null || _theme$components4$dr === void 0 ? void 0 : _theme$components4$dr.label;
});

exports.Label = Label;